import { MultiUser } from "@solidwhite/multiuser";

const MultiUserAppWrapper = ({ children }) => {
  return (
    <MultiUser settings={import.meta.env.VITE_WS_SERVER ? { url: import.meta.env.VITE_WS_SERVER } : undefined}>
      {children}
    </MultiUser>
  );
};

export default MultiUserAppWrapper;
